export default __webpack_public_path__ + "static/media/litho-demo-startup.7d1cd3f5.jpg";